/*
 * Copyright (c) 2025 Hardfin, Inc.
 */
import { Box, TableCell, TableHead, TableRow } from '@mui/material';

export function TicketTableStaticHeader() {
  return (
    <TableHead>
      <TableRow>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Title</Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Category</Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Assigned To</Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Created At</Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Assets</Box>
        </TableCell>
        <TableCell>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>Projects</Box>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}
